import { createStore } from 'services/Flux'
import { actionsType } from 'config/constants'
import Immutable from 'immutable';


const setLoading = (state, action) => {
    let newState = { ...state };
    newState.loading = action.payload;
    return newState;
}

const setRatings = (state, action) => {
    if (!action.payload) {
        return state;
    }

    let newState = { ...state };

    action.payload.map(_item => {
        newState.ratings = newState.ratings.set(_item.id, _item);
    });


    return newState;
}

const Store = createStore((state, action) => {
    switch(action.type) {
        case actionsType.STORES.UPDATE_RATING:
            return setRatings(state, action)
        case actionsType.STORES.SET_LOADING_RATING:
            return setLoading(state, action)
        default: 
            return state
    }
}, {
    loading: false,
    ratings: Immutable.OrderedMap()
}, 'store' )

export default Store